import Vue from 'vue';
import VueRouter from 'vue-router';
import updateToken from '@/middlewares/updateToken-middleware';
import store from '@/store';
import paths from './paths';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  routes: paths,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    store.dispatch('app/setBreadcrumbs', to.meta.breadcrumbs);

    if (!Vue.$keycloak.authenticated) {
      if (to.name === 'Inicio') {
        Vue.$keycloak.login({ scope: 'id_institucional' });
      } else {
        store.dispatch('app/setLoginExpirado', true);
      }
    } else {
      updateToken();
    }
  }
  next();
});

export default router;
